import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { WarehouseGoodUsageStatus } from '../../enums/warehouse-good-usage-status';
import { Guid } from '@web/utils';
import { AdminWarehouseGoodConnectedObjectResponse } from './admin-warehouse-good-connected-object.response';

@jsonObject
export class AdminWarehouseGoodUsageResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly status!: WarehouseGoodUsageStatus;

  @jsonArrayMember(AdminWarehouseGoodConnectedObjectResponse)
  public readonly connectedObjects!: AdminWarehouseGoodConnectedObjectResponse[];
}
